import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const Row = ({ children, second }) => (
	<div className={cx(styles.row, second && styles.rowSecond)}>{children}</div>
);

Row.propTypes = {
	children: PropTypes.node.isRequired,
	second: PropTypes.bool
};

export default Row;
